import { updateField } from 'vuex-map-fields';
import types from './mutations-types';

const mutations = {
  updateField,
  [types.SET_COMPANY_CATEGORIES](state, payload) {
    state.companyCategories = payload;
  },

  [types.SET_COMPANY_ALL_USERS](state, payload) {
    state.companyAllUsers = payload;
  },

  [types.SET_COMPANY_USERS](state, payload) {
    state.myUsers = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/settings/mutations.js